





import { Component, Prop, Vue, Emit } from 'vue-property-decorator'

@Component
export default class VHeading extends Vue {
  @Prop({ default: '' })
  text!: string

  @Prop({ default: '40px' })
  height!: string

  get styles() {
    return {
      '--height': this.height,
    }
  }
}
